import React from 'react';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons/faSpinnerThird';

export function Loader({ iconProps }: { iconProps?: Partial<FontAwesomeIconProps> }) {
  return (
    <FontAwesomeIcon icon={faSpinnerThird} color="orange" spin size={iconProps?.size || '1x'} />
  );
}
